import { notify } from 'app/services/errorReporter';
import { debug } from 'app/services/logger';
import { flattenBatchedActions } from 'app/utils/redux';

const errors = store => next => action => {
  // Can't derive any meaningful information from thunks.
  if (action && typeof action !== 'function') {
    // Get a list of action types for batched actions.
    const actionTypes = flattenBatchedActions(action).map(({ type }) => type);

    debug(`Executing action(s): ${actionTypes.join(', ')}`);
  }

  try {
    const results = next(action);
    return results;
  } catch (error) {
    notify(error, { name: 'DispatchError' });
    throw error;
  }
};

export default errors;
